import React from 'react';

import LookupStatusBadge, { LookupStatus } from '~components/LookupStatusBadge';
import { Row } from '~components/table-view';

interface ComponentProps {
  row: Row;
}

type ClaimStatus = 'not_claimed' | 'part_claimed' | 'claimed';

const STATUS_LABELS: Record<ClaimStatus, string> = {
  not_claimed: 'Not Claimed',
  part_claimed: 'Part Claimed',
  claimed: 'Claimed',
};

// Hex with leading '#' is intentional — preserves the existing visual
// identity (Bootstrap 5 grey / orange / green) and the LookupStatusBadge
// strip-leading-hash helper makes either form work.
const STATUS_COLOURS: Record<ClaimStatus, string> = {
  not_claimed: '#adb5bd',
  part_claimed: '#fd7e14',
  claimed: '#198754',
};

function deriveClaimStatus(items: Row[]): ClaimStatus {
  if (!items?.length) return 'not_claimed';
  const claimedCount = items.filter((item) => item.is_claimed).length;
  if (claimedCount === 0) return 'not_claimed';
  if (claimedCount === items.length) return 'claimed';
  return 'part_claimed';
}

const toLookupStatus = (status: ClaimStatus): LookupStatus => ({
  tag: status,
  name: STATUS_LABELS[status],
  colour: STATUS_COLOURS[status],
});

const ClaimStatusBadge: React.FC<ComponentProps> = ({ row }) => {
  const status = deriveClaimStatus(row.items ?? []);
  return <LookupStatusBadge status={toLookupStatus(status)} />;
};

export default ClaimStatusBadge;
